import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: "#FBAE23", // Primary color (red)
    },
    secondary: {
      main: "#FFDDA1", // Secondary color (pink)
    },
    lightred: {
      main: "#FFEFEE", // Light Red color
      light: "rgba(255, 239, 238, 0.2)", // Light Red with 20% opacity
    },
    dark: {
      main: "#161616", // Dark color
    },
    gray: {
      main: "#CFCFCF", // Gray color
    },
    lightgray: {
      main: "#F5F6FA", // Light gray color
    },
    light: {
      main: "#F8F8FF", // Light color
    },
    secondaryText: {
      main: "#4A4C4E", // Secondary Text color
    },
    green: {
      main: "#00B69B", // Green color
      light: "rgba(0, 182, 155, 0.2)", // Green with 20% opacity
    },
    brown: {
      main: "#AB6004", // Brown color
      light: "rgba(171, 96, 4, 0.2)", // Brown with 20% opacity
    },
    blue: {
      main: "#6226EF", // Blue color
      light: "rgba(98, 38, 239, 0.2)", // Blue with 20% opacity
    },
    orange: {
      main: "#FFA756", // Orange color
      light: "rgba(255, 167, 86, 0.2)", // Orange with 20% opacity
    },
    background: {
      default: "#FFF7E7", // Background color
    },
    text: {
      primary: "#202224", // Default text color
    },
    sidenavbgc: {
      main: "#F8F8F8", // Default text color
    },
    accent: {
      main: "#FFC300", // Accent color
    },
    primaryYellow: {
      main: "#FBAE23",
    },
    lightgreen:{
      main:"#DDFFFA",
    },
    danger: {
      main: "#FF3B30", // Light Red color
      light: "#FFDDDD", // Light Red
    },
  },

  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:not(.MuiInputBase-multiline)': {
            height: '40px', // Fixed height for single-line inputs
          },
          '& .MuiInputBase-input': {
            padding: '12px', // Adjust padding for single-line inputs
          },
          '&.MuiInputBase-multiline': {
            padding: 0, // Remove padding for multiline inputs
          },
        },
      },
    },
  },

  components: {
    // Your existing component overrides
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&:not(.MuiInputBase-multiline)': {
            height: '40px',
          },
          '& .MuiInputBase-input': {
            padding: '12px',
          },
          '&.MuiInputBase-multiline': {
            padding: 0,
          },
        },
      },
    },
    // Add MuiAutocomplete overrides here
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          borderRadius: '8px', // Optional styling for the dropdown
          backgroundColor: '#F5F6FA', // Background color for the dropdown
        },
        option: {
          '&:hover': {
            backgroundColor: '#FFEFEE !important', // Pink hover color
          },
        },
      },
    },
  },
  typography: {
    title: {
      fontFamily: 'Nunito Sans',
      fontSize: '32px',
      fontWeight: 700,
      lineHeight: '43.65px',
      textAlign: 'left',
    },
    buttonL: {
      width: '120px',
      height: '22px',
      top: '28px',
      left: '28px',
      gap: '0px',
      opacity: '1', // set to 1 to make it visible
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '21.82px',
      textAlign: 'left',
    },
    buttonS: {
      fontFamily: 'Nunito Sans',
      fontSize: '12px',
      fontWeight: 700,
      lineHeight: '21.82px',
      textAlign: 'left',
    },
    SubTitleBold: {
      fontFamily: 'Nunito Sans',
      fontSize: '24px',
      fontWeight: 700,
      lineHeight: '32.74px',
      textAlign: 'left',
    },
    subTitle: {
      fontFamily: 'Nunito Sans',
      fontSize: '24px',
      fontWeight: 500,
      lineHeight: '32.74px',
      textAlign: 'left',
    },
    HeadingLarge: {
      fontFamily: 'Nunito Sans',
      fontSize: '18px',
      fontWeight: 700,
      lineHeight: '32.74px',
      textAlign: 'left',
    },
    heading: {
      fontFamily: 'Nunito Sans',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '21.82px',
      textAlign: 'left',
    },
    headingLarge: {
      fontFamily: 'Nunito Sans',
      fontSize: '18px',
      fontWeight: 700,
      lineHeight: '21.82px',
      textAlign: 'left',
    },
    subHeading: {
      fontFamily: 'Nunito Sans',
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: '19.1px',
      textAlign: 'left',
    },
    bodyText1: {
      fontFamily: 'Nunito Sans',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '19.1px',
      textAlign: 'left',
    },
    bodyText2: {
      fontFamily: 'Nunito Sans',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '19.1px',
      textAlign: 'left',
    },
    miniText: {
      fontFamily: 'Nunito Sans',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '19.1px',
      textAlign: 'left',
    },
  },
  buttons: {
    large: {
      lightColor: {
        width: '250px',
        height: '56px',
        gap: '0px',
        borderRadius: '12px',
        border: '2px solid #FF5148',
        opacity: '80%',
        backgroundColor: '#F8F8FF',
        color: '#FF5148',
      },
      primaryColor: {
        width: '250px',
        height: '56px',
        gap: '0px',
        borderRadius: '12px',
        opacity: '0px',
        backgroundColor: '#FF5148',
        color: '#F8F8FF',
      },
    },
    medium: {
      lightColor: {
        width: '250px',
        height: '44px',
        gap: '0px',
        borderRadius: '8px',
        border: '2px solid #FF5148',
        opacity: '0px',
        backgroundColor: '#F8F8FF',
        color: '#FF5148',
      },
      primaryColor: {
        width: '250px',
        height: '44px',
        gap: '0px',
        borderRadius: '8px',
        opacity: '0px',
        backgroundColor: '#FF5148',
        color: '#F8F8FF',
      },
    },
    small: {
      lightColor: {
        width: '120px',
        height: '36px',
        gap: '0px',
        borderRadius: '8px',
        border: '2px solid #FF5148',
        opacity: '0px',
        backgroundColor: '#F8F8FF',
        color: '#FF5148',
      },
      primaryColor: {
        width: '120px',
        height: '36px',
        gap: '0px',
        borderRadius: '8px',
        opacity: '0px',
        backgroundColor: '#FF5148',
        color: '#F8F8FF',
      },
    },
  },
  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '12px',
    xl: '16px',
    xxl: '20px',
  },
});

export default theme;
